export const selectIsTransferMoneyFeatureEnabled = (state) => {
  const loggedInResponse = state.loggedInResponse ? JSON.parse(state.loggedInResponse) : null;
  return loggedInResponse?.IsTransferMoneyFeatureEnabled === true;
};

export const selectHasKudzuCard = (state) => {
  if (state.hasKudzuCard) return true;
  const cards = state.userCards ? JSON.parse(state.userCards) : null;
  return cards?.some(card => card?.AccountTypeBit63 === 64) || false;
};
